package com.vizio.redwolf.utils

data class IdentityProxyEnvironmentConfig(val environmentGroup: EnvironmentGroup)